/**
 * tolling-api v2
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActivityPricingResponseDto } from './activityPricingResponse';
import { ActivityLocationResponseDto } from './activityLocationResponse';
import { ActivityDistanceResponseDto } from './activityDistanceResponse';

export interface ActivityDetailsResponseDto {
    type: ActivityDetailsResponseDto.TypeEnum;
    location: ActivityLocationResponseDto;
    distance?: ActivityDistanceResponseDto;
    pricing: ActivityPricingResponseDto;
}
export namespace ActivityDetailsResponseDto {
    export const TypeEnum = {
        Toll: 'TOLL',
    } as const;
    export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];
}
